import Vue from "vue";
import Vuetify from "vuetify/lib";
// import "@mdi/font/css/materialdesignicons.css"; // Ensure you are using css-loader

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#4caf50",
        secondary: "#4caf50",
        tertiary: "#495057",
        accent: "#82B1FF",
        error: "#f55a4e",
        info: "#00d3ee",
        success: "#5cb860",
        warning: "#ffa21a"
      },
      dark: {
        primary: "#4caf50",
        secondary: "#4caf50",
        tertiary: "#495057",
        accent: "#82B1FF",
        error: "#f55a4e",
        info: "#00d3ee",
        success: "#5cb860",
        warning: "#ffa21a",
        general: "#2196F3"
      }
    },
    dark: false
  },
  icons: {
    iconfont: "mdi"
  }
});
